import { Check, MessageCircle } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { whatsappLink } from "@/lib/dtf";

const features = [
  "Impressão DTF têxtil sob demanda",
  "Atendimento rápido",
  "Produção para pequenas e grandes quantidades",
  "Ideal para estamparias e personalizados",
  "Envio para todo o Brasil",
];

export const Commercial = () => (
  <section className="bg-white py-16 sm:py-20 lg:py-24">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
        <Reveal>
          <p className="num text-[11px] uppercase tracking-[0.28em] text-[#f58244]">
            Terceirize com a gente
          </p>
          <h2 className="mt-3 text-3xl font-extrabold leading-tight text-black sm:text-4xl lg:text-[3rem]">
            Precisa imprimir seu DTF têxtil?
          </h2>
          <p className="mt-5 max-w-xl text-sm leading-relaxed text-neutral-600 sm:text-base">
            Além de calcular, você também pode encomendar sua impressão DTF
            têxtil diretamente conosco. Envie sua arte e fale com nossa equipe
            pelo WhatsApp.
          </p>

          <ul className="mt-8 space-y-3">
            {features.map((f, i) => (
              <li
                key={f}
                data-testid={`commercial-feature-${i + 1}`}
                className="flex items-start gap-3 text-sm font-medium text-black sm:text-base"
              >
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#f58244]">
                  <Check className="h-3 w-3 text-white" strokeWidth={3.5} />
                </span>
                {f}
              </li>
            ))}
          </ul>

          <a
            href={whatsappLink(
              "Olá! Gostaria de solicitar uma impressão DTF têxtil. Vim pelo ClickDTF.",
            )}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="commercial-cta-whatsapp"
            className="mt-9 inline-flex items-center gap-2 rounded-full bg-[#f58244] px-7 py-4 text-base font-semibold text-white shadow-[0_16px_34px_-16px_rgba(245,130,68,1)] transition-transform duration-200 hover:-translate-y-0.5 hover:bg-[#e06f32]"
          >
            <MessageCircle className="h-4 w-4" strokeWidth={2.6} />
            Envie sua arte agora
          </a>
        </Reveal>

        <Reveal delay={0.12}>
          <figure className="relative overflow-hidden rounded-[26px] border border-neutral-200">
            <img
              src="https://images.pexels.com/photos/9314012/pexels-photo-9314012.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=800"
              alt="Impressão DTF têxtil profissional sendo produzida em filme"
              loading="lazy"
              className="h-[380px] w-full object-cover transition-transform duration-[900ms] hover:scale-[1.04] sm:h-[520px]"
            />
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
            <figcaption className="absolute bottom-0 left-0 right-0 p-6">
              <p className="num text-[11px] uppercase tracking-[0.24em] text-[#f58244]">
                Produção
              </p>
              <p className="mt-2 max-w-xs text-base font-bold text-white sm:text-lg">
                Sua arte impressa em filme têxtil e pronta para a prensa.
              </p>
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </div>
  </section>
);
